export default __webpack_public_path__ + "static/media/person_1.b9b9d94f.png";